// src/pages/StudentPanel.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const api = axios.create({ baseURL: '/api/student' });

export default function StudentPanel() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);
    const [exams, setExams] = useState([]);
    const [guestExams, setGuestExams] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        Promise.all([
            api.get('/egzaminy/zaplanowane', { headers: { Authorization: `Bearer ${token}` }}),
            api.get('/egzaminy/kod/zaplanowane', { headers: { Authorization: `Bearer ${token}` }}),
        ])
            .then(([r1, r2]) => {
                setExams(r1.data || []);
                setGuestExams(Array.isArray(r2.data) ? r2.data : []);
            })
            .catch(e => setErr(e?.response?.data?.blad || 'Błąd pobierania'))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ padding: '0 16px', marginTop:80 }}>
            <h1 style={{ marginBottom: 16  }}>Egzaminy - przyszłe</h1>

            <div style={{ display:'flex', gap:8, margin:'12px 0 20px' }}>
                <button className={'but-smal'}
                        onClick={() => navigate('/student/egzamin/dodaj-kod')}
                        style={{ border:'1px solid #e5e7eb', borderRadius:8 }}>
                    + Dołącz do egzaminu za pomocą kodu
                </button>
            </div>

            <h2 style={{ margin: '8px 0 12px' }}>Nadchodzące terminy (grupy)</h2>
            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color: 'crimson' }}>{err}</div>
            ) : exams.length === 0 ? (
                <EmptyState />
            ) : (
                <div style={{ display: 'grid', gap: 12 }}>
                    {exams.map(ex => (
                        <ExamCard key={ex.term_id} exam={ex} />
                    ))}
                </div>
            )}

            <h2 style={{ margin: '20px 0 12px' }}>Dołączono za pomocą kodu</h2>
            {loading ? (
                <div>Ładowanie…</div>
            ) : guestExams.length === 0 ? (
                <div style={{ border:'1px dashed #d1d5db', borderRadius: 12, padding: 20, color: '#6b7280' }}>
                    Brak terminów dołączonych kodem.
                </div>
            ) : (
                <div style={{ display:'grid', gap:12 }}>
                    {guestExams.map(ex => (
                        <ExamCard key={ex.attempt_id} exam={{
                            ...ex,
                            // dopasuj pola do karty
                            group_name: ex.group_name || '(gość — kod)',
                        }} />
                    ))}
                </div>
            )}
        </div>
    );
}

function ExamCard({ exam }) {
    const navigate = useNavigate();
    const go = () => navigate(`/student/egzamin/termin/${exam.term_id}/start`);

    return (
        <div
            role="button"
            onClick={go}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && go()}
            tabIndex={0}
            style={{
                border: '1px solid #e5e7eb',
                borderRadius: 12,
                padding: 14,
                background: 'white',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'box-shadow .15s ease, transform .02s ease'
            }}
        >
            <div>
                <div style={{ fontWeight: 600 }}>{exam.title}</div>
                <div style={{ color: '#6b7280', fontSize: 14 }}>
                    {exam.group_name} • {new Intl.DateTimeFormat('pl-PL', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(exam.exam_datetime))} • {exam.exam_duration} min
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#111827' }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>Przejdź</span>
                <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>➜</span>
            </div>
        </div>
    );
}

function EmptyState() {
    return (
        <div style={{ border: '1px dashed #d1d5db', borderRadius: 12, padding: 20, color: '#6b7280' }}>
            Brak zaplanowanych egzaminów.
        </div>
    );
}
